import React from 'react';
import { maskDayOfWeek, maskTimeBlock } from '../../masks';

class ChefAvailabilityList extends React.Component {
  render() {
    const { list = [], showMobileWarning = false } = this.props;
    return (
      <div className="chef-availability--list">
        <div className="chef-availability__list">
          {list.map((avails, i) => this.renderListDay(avails, i))}
        </div>
        {showMobileWarning && (
          <p className="small">Availability not editable on mobile.</p>
        )}
      </div>
    );
  }

  renderListDay(avails, i) {
    return (
      <div key={i} className="chef-availability__li">
        <div className="chef-availability__col chef-availability__col--day">
          <p className="p p--bold">{maskDayOfWeek(i)}</p>
        </div>
        <div className="chef-availability__col chef-availability__col--block">
          <p className="p">
            {avails.length > 0
              ? avails
                  .map(
                    avail =>
                      `${maskTimeBlock(avail.start_time)} - ${maskTimeBlock(
                        avail.end_time
                      )}`
                  )
                  .join(', ')
              : 'Unavailable'}
          </p>
        </div>
      </div>
    );
  }
}
export default ChefAvailabilityList;



// WEBPACK FOOTER //
// ./src/components/chef/ChefAvailabilityList.js